function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  className: styles["icon"] || "icon",
  height: "512",
  viewBox: "195.392 0 633.216 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M509.632 766.72l-314.24-185.6L509.632 1024l314.432-442.88-314.496 185.6zM514.368 0l-314.24 521.472 314.24 185.792 314.24-185.6L514.368 0z"
})));